(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Contact', Contact);

  Contact.$inject = ['$resource', 'API_URI'];

  function Contact($resource, API_URI) {
    var resourceUrl = API_URI + 'api/contacts/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'queryActive': {
        url: API_URI + 'api/contacts/active',
        method: 'GET',
        isArray: true
      },
      'getUserContacts': {
        url: API_URI + 'api/contacts/active/:userId',
        method: 'GET',
        isArray: true,
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
